function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import HubspotContactFormFields from "segments/desktop/core-components/hubspot-contact-form/fields-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Hubspot On Purple Background",
    fields: _object_spread_props(_object_spread({}, HubspotContactFormFields), {
        formTitleFontSize: {
            type: FIELD_TYPES.TEXT,
            label: "Form Title Font Size (e.g. 1rem, 24px)"
        },
        LeftSideContent: {
            type: FIELD_TYPES.NESTED,
            label: "Left Side Content",
            fields: {
                eyebrow: {
                    type: FIELD_TYPES.TEXT,
                    label: "Eyebrow"
                },
                eyebrowFontSize: {
                    type: FIELD_TYPES.TEXT,
                    label: "Eyebrow Font Size (e.g. 0.875rem, 14px)"
                },
                title: {
                    type: FIELD_TYPES.TEXT,
                    label: "Title"
                },
                valuesList: {
                    type: FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Values List",
                    nestedConfig: {
                        type: FIELD_TYPES.NESTED,
                        fields: {
                            value: {
                                type: FIELD_TYPES.TEXT,
                                label: "Value"
                            }
                        }
                    }
                },
                supportText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Support Text"
                },
                helpCenterLinkText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Help Center Link Text"
                },
                helpCenterLinkUrl: {
                    type: FIELD_TYPES.TEXT,
                    label: "Help Center Link Url"
                },
                sentenceAboveLogos: {
                    type: FIELD_TYPES.TEXT,
                    label: "Sentence Above Logos"
                },
                logos: {
                    type: FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Logos",
                    nestedConfig: {
                        type: FIELD_TYPES.NESTED,
                        fields: _object_spread({}, AssetFieldsConfig.image.fields)
                    }
                }
            }
        }
    })
};
